import { useQuery } from '@apollo/client/react'
import { Card, Input, Table, type TableColumnProps } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  type Customer,
  FindCustomerDocument,
} from '~app/graph/generated/graphql'
import CustomerDetailsModal from '../../components/Elements/CustomerDetailsModal/CustomerDetailsModal'
import UploadPaywallCSVButton from './UploadPaywallCSVButton'

const CustomerDetailsRoute = () => {
  const { t } = useTranslation()

  const columns: TableColumnProps<Customer>[] = [
    {
      title: 'Public ID',
      dataIndex: 'encodedPublicId',
    },
    {
      title: t('misc.firstName'),
      dataIndex: 'firstName',
    },
    {
      title: t('misc.lastName'),
      dataIndex: 'lastName',
    },
  ]
  const [searchText, setSearchText] = useState('')
  const [searching, setSearching] = useState(false)
  const [selectedCustomerId, setSelectedCustomerId] = useState<
    string | undefined
  >()

  const { data, loading } = useQuery(FindCustomerDocument, {
    variables: { searchText },
  })

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <UploadPaywallCSVButton />
      </div>
      <Card>
        <Input.Search
          placeholder={t('searchCustomerInputPlaceholder')}
          enterButton
          disabled={loading}
          onSearch={searchText => {
            if (searchText === '' || searchText.length < 3) {
              return
            }

            setSearching(true)
            setSearchText(searchText)
          }}
        />
      </Card>
      {searching && (
        <Table
          style={{ marginTop: 16 }}
          loading={loading}
          columns={columns}
          dataSource={data?.findCustomers ?? []}
          rowKey="id"
          pagination={false}
          onRow={customer => ({
            onClick: () => setSelectedCustomerId(customer.id),
            style: { cursor: 'pointer' },
          })}
        />
      )}
      {selectedCustomerId &&
        data?.findCustomers?.find(c => c.id === selectedCustomerId) && (
          <CustomerDetailsModal
            visible
            close={() => setSelectedCustomerId(undefined)}
            customer={
              data.findCustomers.find(c => c.id === selectedCustomerId)!
            }
          />
        )}
    </div>
  )
}

export default CustomerDetailsRoute
